/**
 * Required for establishing a socket connection.
 */
export const REALTIME_CONNECTION_EVENT = 'websocket_authentication';

export const DEFAULT_CONTROLLER = 'v5';

export const DEFAULT_ACTION = 'general';

/**
 * A human readable error message, for all
 * socket connection related errors.
 */
export const FAILED_TO_INITIALIZE = 'Failed to initialize a web socket connection';
